/* ============================================================
   ENIGMAE — Premium Slide-In Cart Drawer
   Intercepts Add to Cart, adds via AJAX, slides in from right
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. Inject CSS ── */
  const CSS = `
    /* Overlay */
    #enig-drawer-overlay {
      display: none;
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.45);
      z-index: 9998;
      opacity: 0;
      transition: opacity 0.35s ease;
    }
    #enig-drawer-overlay.enig-open {
      display: block;
      opacity: 1;
    }

    /* Drawer panel */
    #enig-cart-drawer {
      position: fixed;
      top: 0;
      right: 0;
      width: 420px;
      max-width: 100vw;
      height: 100%;
      background: #fff;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      transform: translateX(100%);
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: -8px 0 40px rgba(0,0,0,0.18);
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }
    #enig-cart-drawer.enig-open {
      transform: translateX(0);
    }

    /* Header */
    .enig-drawer-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 22px 24px 18px;
      border-bottom: 1px solid #f0f0f0;
      background: #fff;
    }
    .enig-drawer-title {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #111;
      margin: 0;
    }
    .enig-drawer-count {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #111;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      margin-left: 8px;
    }
    .enig-drawer-close {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      color: #111;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.2s;
    }
    .enig-drawer-close:hover { opacity: 0.5; }
    .enig-drawer-close svg { width: 22px; height: 22px; }

    /* Body / items */
    .enig-drawer-body {
      flex: 1;
      overflow-y: auto;
      padding: 0;
    }
    .enig-drawer-body::-webkit-scrollbar { width: 4px; }
    .enig-drawer-body::-webkit-scrollbar-track { background: #f9f9f9; }
    .enig-drawer-body::-webkit-scrollbar-thumb { background: #ddd; border-radius: 2px; }

    /* Empty state */
    .enig-drawer-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 40px 24px;
      text-align: center;
      color: #888;
    }
    .enig-drawer-empty svg { width: 56px; height: 56px; margin-bottom: 16px; opacity: 0.3; }
    .enig-drawer-empty p { font-size: 15px; margin: 0 0 20px; }
    .enig-drawer-empty a {
      display: inline-block;
      padding: 12px 28px;
      background: #111;
      color: #fff;
      text-decoration: none;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      transition: background 0.2s;
    }
    .enig-drawer-empty a:hover { background: #333; }

    /* Cart item */
    .enig-cart-item {
      display: flex;
      gap: 14px;
      padding: 18px 24px;
      border-bottom: 1px solid #f5f5f5;
      position: relative;
      animation: enigSlideIn 0.3s ease;
    }
    @keyframes enigSlideIn {
      from { opacity: 0; transform: translateY(-8px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .enig-item-img {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 4px;
      flex-shrink: 0;
      background: #f5f5f5;
    }
    .enig-item-info { flex: 1; min-width: 0; }
    .enig-item-title {
      font-size: 13px;
      font-weight: 600;
      color: #111;
      margin: 0 0 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .enig-item-variant {
      font-size: 12px;
      color: #888;
      margin: 0 0 10px;
    }
    .enig-item-price {
      font-size: 14px;
      font-weight: 700;
      color: #111;
    }
    .enig-item-qty-row {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
    }
    .enig-qty-btn {
      width: 28px;
      height: 28px;
      border: 1px solid #ddd;
      background: #fff;
      cursor: pointer;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      transition: background 0.15s;
      color: #111;
      line-height: 1;
    }
    .enig-qty-btn:hover { background: #f5f5f5; }
    .enig-qty-val {
      font-size: 13px;
      font-weight: 600;
      min-width: 20px;
      text-align: center;
      color: #111;
    }
    .enig-item-remove {
      position: absolute;
      top: 16px;
      right: 20px;
      background: none;
      border: none;
      cursor: pointer;
      color: #bbb;
      font-size: 18px;
      padding: 2px 4px;
      line-height: 1;
      transition: color 0.2s;
    }
    .enig-item-remove:hover { color: #111; }

    /* Footer */
    .enig-drawer-footer {
      padding: 20px 24px 28px;
      border-top: 1px solid #f0f0f0;
      background: #fff;
    }
    .enig-subtotal-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
    }
    .enig-subtotal-label {
      font-size: 13px;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.06em;
    }
    .enig-subtotal-price {
      font-size: 18px;
      font-weight: 700;
      color: #111;
    }
    .enig-free-ship-note {
      font-size: 12px;
      color: #888;
      margin-bottom: 16px;
      text-align: center;
    }
    .enig-free-ship-bar-wrap {
      background: #f0f0f0;
      border-radius: 4px;
      height: 4px;
      margin-bottom: 16px;
      overflow: hidden;
    }
    .enig-free-ship-bar {
      height: 100%;
      background: #111;
      border-radius: 4px;
      transition: width 0.5s ease;
    }
    .enig-checkout-btn {
      display: block;
      width: 100%;
      padding: 16px;
      background: #111;
      color: #fff;
      text-align: center;
      text-decoration: none;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      border: none;
      cursor: pointer;
      border-radius: 3px;
      transition: background 0.2s, transform 0.1s;
      margin-bottom: 10px;
    }
    .enig-checkout-btn:hover { background: #333; transform: translateY(-1px); }
    .enig-view-cart-btn {
      display: block;
      width: 100%;
      padding: 13px;
      background: #fff;
      color: #111;
      text-align: center;
      text-decoration: none;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      border: 1px solid #ddd;
      cursor: pointer;
      border-radius: 3px;
      transition: background 0.2s;
    }
    .enig-view-cart-btn:hover { background: #f9f9f9; }

    /* Loading spinner */
    .enig-drawer-loading {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
    }
    .enig-spinner {
      width: 32px;
      height: 32px;
      border: 3px solid #f0f0f0;
      border-top-color: #111;
      border-radius: 50%;
      animation: enigSpin 0.7s linear infinite;
    }
    @keyframes enigSpin { to { transform: rotate(360deg); } }

    /* Added to cart flash */
    .enig-atc-btn.enig-adding {
      opacity: 0.7;
      pointer-events: none;
    }
    .enig-atc-btn.enig-added {
      background: #2a7a2a !important;
      color: #fff !important;
    }

    /* Buy It Now Button */
    .enig-buy-now-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 16px 24px;
      margin-top: 10px;
      background: linear-gradient(135deg, #7B2FF7 0%, #F107A3 100%);
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      text-decoration: none;
      cursor: pointer;
      transition: opacity 0.2s ease, transform 0.15s ease;
      font-family: inherit;
      box-shadow: 0 4px 18px rgba(123,47,247,0.35);
    }
    .enig-buy-now-btn:hover {
      opacity: 0.9;
      transform: translateY(-1px);
      box-shadow: 0 6px 22px rgba(123,47,247,0.45);
    }
    .enig-buy-now-btn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    /* Shipping Cut-off Urgency Bar */
    .enig-cutoff-bar {
      display: flex;
      align-items: center;
      gap: 8px;
      background: #fff8e1;
      border: 1px solid #ffe082;
      border-radius: 6px;
      padding: 9px 14px;
      margin-bottom: 12px;
      font-size: 13px;
      color: #5d4037;
      font-weight: 500;
    }
    .enig-cutoff-bar strong {
      color: #c62828;
      font-weight: 700;
      font-variant-numeric: tabular-nums;
    }
    .enig-cutoff-icon { font-size: 16px; }

    /* Size Guide Link */
    .enig-size-guide-link {
      background: none;
      border: none;
      color: #7B2FF7;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      text-decoration: underline;
      margin-left: 10px;
      padding: 0;
      font-family: inherit;
    }
    .enig-size-guide-link:hover { color: #F107A3; }

    /* Fit Tip */
    .enig-fit-tip {
      font-size: 12px;
      color: #2a7a2a;
      margin: 4px 0 8px;
      font-weight: 500;
    }

    /* Payment Icons */
    .enig-pay-row {
      margin-top: 16px;
    }
    .enig-pay-label {
      display: block;
      font-size: 11px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #888;
      margin-bottom: 8px;
    }
    .enig-pay-logos {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      align-items: center;
    }
    .enig-pay-logo-wrap {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 3px rgba(0,0,0,0.12);
    }
    .enig-pay-logo-img {
      width: 42px;
      height: 27px;
      display: block;
    }

    @media (max-width: 480px) {
      #enig-cart-drawer { width: 100vw; }
      .enig-pay-logo-img { width: 36px; height: 23px; }
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  /* ── 2. Build Drawer HTML ── */
  const overlay = document.createElement('div');
  overlay.id = 'enig-drawer-overlay';
  document.body.appendChild(overlay);

  const drawer = document.createElement('div');
  drawer.id = 'enig-cart-drawer';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-label', 'Shopping cart');
  drawer.innerHTML = `
    <div class="enig-drawer-header">
      <div style="display:flex;align-items:center;">
        <h2 class="enig-drawer-title">Your Cart</h2>
        <span class="enig-drawer-count" id="enig-drawer-count">0</span>
      </div>
      <button class="enig-drawer-close" id="enig-drawer-close" aria-label="Close cart">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
    <div class="enig-drawer-body" id="enig-drawer-body">
      <div class="enig-drawer-loading"><div class="enig-spinner"></div></div>
    </div>
    <div class="enig-drawer-footer" id="enig-drawer-footer" style="display:none;">
      <div class="enig-subtotal-row">
        <span class="enig-subtotal-label">Subtotal</span>
        <span class="enig-subtotal-price" id="enig-subtotal">€0.00</span>
      </div>
      <div class="enig-free-ship-note" id="enig-ship-note"></div>
      <div class="enig-free-ship-bar-wrap"><div class="enig-free-ship-bar" id="enig-ship-bar" style="width:0%"></div></div>
      <a href="/checkout" class="enig-checkout-btn">Checkout →</a>
      <a href="/cart" class="enig-view-cart-btn">View Full Cart</a>
    </div>
  `;
  document.body.appendChild(drawer);

  /* ── 3. Open / Close ── */
  const FREE_SHIP_THRESHOLD = 8000; // €80 in cents

  function openDrawer() {
    overlay.classList.add('enig-open');
    drawer.classList.add('enig-open');
    document.body.style.overflow = 'hidden';
    loadCart();
  }

  function closeDrawer() {
    overlay.classList.remove('enig-open');
    drawer.classList.remove('enig-open');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeDrawer);
  document.getElementById('enig-drawer-close').addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ── 4. Render Cart ── */
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderCart(cart) {
    const body = document.getElementById('enig-drawer-body');
    const footer = document.getElementById('enig-drawer-footer');
    const countEl = document.getElementById('enig-drawer-count');

    countEl.textContent = cart.item_count || 0;

    if (!cart.items || cart.items.length === 0) {
      footer.style.display = 'none';
      body.innerHTML = `
        <div class="enig-drawer-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 8h12l1 12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L6 8z"/>
            <path d="M9 8V6a3 3 0 0 1 6 0v2"/>
          </svg>
          <p>Your cart is empty</p>
          <a href="/collections/all">Continue Shopping</a>
        </div>`;
      return;
    }

    footer.style.display = 'block';

    // Free shipping bar
    const total = cart.total_price;
    const remaining = FREE_SHIP_THRESHOLD - total;
    const pct = Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100);
    document.getElementById('enig-ship-bar').style.width = pct + '%';
    if (remaining > 0) {
      document.getElementById('enig-ship-note').textContent =
        `Add ${formatMoney(remaining)} more for free shipping`;
    } else {
      document.getElementById('enig-ship-note').textContent = '🎉 You qualify for free shipping!';
    }

    document.getElementById('enig-subtotal').textContent = formatMoney(total);

    body.innerHTML = cart.items.map((item, idx) => `
      <div class="enig-cart-item" data-key="${item.key}" data-idx="${idx}">
        <img class="enig-item-img"
             src="${item.image ? item.image.replace(/(\.[a-z]+)$/, '_80x80_crop_center$1') : ''}"
             alt="${item.product_title}"
             loading="lazy">
        <div class="enig-item-info">
          <p class="enig-item-title">${item.product_title}</p>
          <p class="enig-item-variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <p class="enig-item-price">${formatMoney(item.final_line_price)}</p>
          <div class="enig-item-qty-row">
            <button class="enig-qty-btn" data-action="dec" data-key="${item.key}">−</button>
            <span class="enig-qty-val">${item.quantity}</span>
            <button class="enig-qty-btn" data-action="inc" data-key="${item.key}">+</button>
          </div>
        </div>
        <button class="enig-item-remove" data-key="${item.key}" aria-label="Remove item">×</button>
      </div>
    `).join('');

    // Qty + remove listeners
    body.querySelectorAll('.enig-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const row = btn.closest('.enig-cart-item');
        const qtyEl = row.querySelector('.enig-qty-val');
        let qty = parseInt(qtyEl.textContent);
        qty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
        updateCartItem(key, qty);
      });
    });
    body.querySelectorAll('.enig-item-remove').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  /* ── 5. Fetch Cart ── */
  function loadCart(retries) {
    retries = retries === undefined ? 3 : retries;
    const body = document.getElementById('enig-drawer-body');
    body.innerHTML = '<div class="enig-drawer-loading"><div class="enig-spinner"></div></div>';
    fetch('/cart.js')
      .then(r => {
        if (r.status === 429 && retries > 0) {
          // Rate limited — retry after 1 second
          setTimeout(() => loadCart(retries - 1), 1000);
          return null;
        }
        return r.json();
      })
      .then(data => { if (data) renderCart(data); })
      .catch(() => {
        if (retries > 0) {
          setTimeout(() => loadCart(retries - 1), 1500);
        } else {
          body.innerHTML = '<div class="enig-drawer-empty"><p>Could not load cart. <a href="/cart" style="color:#111;text-decoration:underline;">View cart page</a></p></div>';
        }
      });
  }

  /* ── 6. Update Item Qty ── */
  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => {
        renderCart(cart);
        updateHeaderCount(cart.item_count);
      });
  }

  /* ── 7. Update header cart count bubble ── */
  function updateHeaderCount(count) {
    // Dawn theme cart bubble
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) {
      const spans = bubble.querySelectorAll('span');
      if (spans[0]) spans[0].textContent = count;
      if (spans[1]) spans[1].textContent = count + ' items';
    }
    // Also update our drawer count
    const dc = document.getElementById('enig-drawer-count');
    if (dc) dc.textContent = count;
  }

  /* ── 8. Intercept Add to Cart ── */
  function interceptAddToCart(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const btn = form.querySelector('.enig-atc-btn') || form.querySelector('[name="add"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1');

      if (!variantId) return;

      // Button feedback
      if (btn) {
        btn.classList.add('enig-adding');
        btn.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(r => r.json())
        .then((data) => {
          if (data && data.status) throw data;
          if (window.enigPublishAddToCart) enigPublishAddToCart(data);
          if (btn) {
            btn.classList.remove('enig-adding');
            btn.classList.add('enig-added');
            btn.textContent = '✓ Added!';
            setTimeout(() => {
              btn.classList.remove('enig-added');
              btn.textContent = 'Add to Cart';
            }, 2000);
          }
          openDrawer();
        })
        .catch(() => {
          if (btn) {
            btn.classList.remove('enig-adding');
            btn.textContent = 'Add to Cart';
          }
          // Fallback: submit normally
          form.submit();
        });
    });
  }

  /* ── 9. Hook into all product forms on page ── */
  function hookForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (form.dataset.enigSkip === 'true') return;
      if (!form.dataset.enigHooked) {
        form.dataset.enigHooked = 'true';
        interceptAddToCart(form);
      }
    });
    // Also hook the enig-atc-btn directly in case it's outside a standard form
    document.querySelectorAll('.enig-atc-btn').forEach(btn => {
      if (!btn.dataset.enigHooked) {
        btn.dataset.enigHooked = 'true';
        btn.addEventListener('click', function(e) {
          const form = btn.closest('form');
          if (form && form.dataset.enigHooked === 'true') return; // already handled by form
          e.preventDefault();
          const variantId = document.getElementById('enig-variant-id')?.value;
          const qty = parseInt(document.getElementById('enig-form-qty')?.value || '1');
          if (!variantId) return;
          btn.classList.add('enig-adding');
          btn.textContent = 'Adding\u2026';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: variantId, quantity: qty})
          })
          .then(r => r.json())
          .then((data) => {
            if (data && data.status) throw data;
            if (window.enigPublishAddToCart) enigPublishAddToCart(data);
            btn.classList.remove('enig-adding');
            btn.classList.add('enig-added');
            btn.textContent = '\u2713 Added!';
            setTimeout(() => { btn.classList.remove('enig-added'); btn.textContent = 'Add to Cart'; }, 2000);
            openDrawer();
          })
          .catch(() => { btn.classList.remove('enig-adding'); btn.textContent = 'Add to Cart'; });
        });
      }
    });
  }

  // Hook immediately and also watch for dynamic content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookForms);
  } else {
    hookForms();
  }

  // Also hook cart icon in header to open drawer
  document.addEventListener('DOMContentLoaded', () => {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      });
    }
  });

  // Expose globally so theme can call it
  window.enigOpenCartDrawer = openDrawer;

})();
